import { AuthContext } from 'contexts/AuthContext';
import Nodatafound from 'pages/Common/Nodatafound';
import { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { BallTriangle } from 'react-loader-spinner';
import nft1 from 'assets/img/nfts/NftBanner1.png';
import testService from 'ApiService/Student/testServices';

const ViewTest = () => {
  const [attendedTests, setAttendedTests] = useState([]);
  const { state } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [selectedTest, setSelectedTest] = useState(null);
  const [filteredTests, setFilteredTests] = useState([]); // Holds the filtered tests
  const [filterOption, setFilterOption] = useState('all');

  const fetchAttendedTests = async () => {
    setLoading(true);
    try {
      const response = await testService.viewAttendedTests();
      if (response.data.success) {
        setAttendedTests(response.data.data || []);
        setFilteredTests(response.data.data || []); // Initially set to all tests
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || 'Failed to fetch attended tests.'
      );
    } finally {
      setLoading(false);
    }
  };

  const handleTestClick = (test) => {
    setSelectedTest(test);
    setShowDetails(true);
  };

  const handleBackClick = () => {
    setSelectedTest(null);
    setShowDetails(false);
  };

  useEffect(() => {
    if (state?.user) {
      fetchAttendedTests();
    }
  }, [state?.user]);

  const handleFilterChange = (event) => {
    const selectedFilter = event.target.value;
    setFilterOption(selectedFilter);

    if (selectedFilter === 'all') {
      setFilteredTests(attendedTests);
    } else {
      const filtered = attendedTests.filter((t) => t.type === selectedFilter);

      if (filtered.length === 0) {
        toast.error(
          `No Assignment available for ${selectedFilter.toUpperCase()} type.`
        );
        setFilteredTests(attendedTests);
      } else {
        setFilteredTests(filtered);
      }
    }
  };

  return (
    <div className="mt-20 h-full w-full rounded-[20px] md:mt-4 md:mt-5">
      {showDetails ? (
        <div className="grid h-full w-full grid-cols-1 gap-4 rounded-lg border p-2">
          <h3 className="text-2xl font-bold text-navy-800 dark:text-white">
            {selectedTest.title}
          </h3>
          <p className="font-bold text-navy-800 dark:text-white">
            Score: {selectedTest.score} / {selectedTest.totalMarks}
          </p>
          {selectedTest.questions.map((question, index) => (
            <div
              key={index}
              className="rounded-lg bg-white p-4 shadow-md dark:bg-navy-900"
            >
              <h5 className="text-lg font-bold text-gray-900 dark:text-white">
                Question {index + 1}: {question.questionText}
              </h5>
              {question.options && (
                <ul className="mt-2">
                  {question.options.map((option, optIndex) => (
                    <li
                      key={optIndex}
                      className="text-gray-700 dark:text-gray-400"
                    >
                      {option}
                    </li>
                  ))}
                </ul>
              )}
              <p className="mt-2 text-green-600 dark:text-green-400">
                Correct Answer: {question.correctAnswer}
              </p>
              <p
                className={`mt-2 ${
                  question.isCorrect
                    ? 'text-green-600 dark:text-green-400'
                    : 'text-red-600 dark:text-red-400'
                }`}
              >
                Your Answer: {question.studentAnswer}
              </p>
            </div>
          ))}

          <div className="mt-4 flex flex-col justify-between px-3 pt-2 md:flex-row ">
            <button
              onClick={handleBackClick}
              className="mb-3 cursor-pointer rounded-xl bg-lightPrimary px-16 py-2 font-medium text-navy-700 transition duration-200 dark:bg-white/5 dark:text-white dark:hover:bg-white/10 dark:active:bg-white/20"
            >
              Go back
            </button>
          </div>
        </div>
      ) : (
        <>
          <select
            id="filter"
            value={filterOption}
            onChange={handleFilterChange}
            className="mb-2 ml-2 mt-5 w-[100px] cursor-pointer rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
          >
            <option value="all">All</option>
            <option value="mcq">MCQ</option>
            <option value="qa">QA</option>
          </select>
          {loading ? (
            <div className="flex h-40 items-center justify-center">
              <BallTriangle color="#5431ed" />
            </div>
          ) : filteredTests.length === 0 ? (
            <div className="flex h-40 items-center justify-center dark:text-gray-600">
              {/* Show message for no tests for the selected schedule */}
              <Nodatafound title={`No ${filterOption} tests found`} />
            </div>
          ) : (
            <div className="grid h-full w-full grid-cols-1 gap-4 p-2 md:grid-cols-2 lg:grid-cols-3">
              {filteredTests.map((test) => (
                <span
                  onClick={() => handleTestClick(test)}
                  key={test.submissionId}
                  className="relative flex cursor-pointer flex-col items-center overflow-hidden rounded-lg border border-gray-200 dark:border-gray-700 dark:bg-navy-800 md:flex-row"
                  style={{ height: '250px', width: '100%' }}
                >
                  <div className="flex w-full flex-col overflow-hidden p-4 leading-normal md:w-2/3">
                    <h5 className="mb-2 truncate  text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                      {test.title}
                    </h5>

                    <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">
                          Score: {test.score} / {test.totalMarks}
                    </p>
                    <p className="mb-3 truncate font-normal text-gray-700 dark:text-gray-400">
                      Submitted:{' '}
                      {new Date(test.submittedAt).toLocaleDateString()}
                    </p>

                  </div>
                </span>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ViewTest;
